module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-panel",
    attrs: {
      "id": "page__customers"
    }
  }, [_c('md-content', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.progress),
      expression: "progress"
    }],
    attrs: {
      "md-theme": "white"
    }
  }, [_c('customer-menu'), _vm._v(" "), _c('sort-table', {
    attrs: {
      "columns": _vm.tableColumns,
      "per-page": _vm.perPage,
      "total": _vm.customersAmount,
      "table-id": "customers",
      "link": "",
      "tableHeight": "calc(100% - 48px)",
      "loadOnScroll": true
    },
    on: {
      "refresh": _vm.getCustomers,
      "create": _vm.addCustomer
    },
    scopedSlots: _vm._u([{
      key: "type",
      fn: function(scope) {
        return [_c('span', [_vm._v(" " + _vm._s(_vm.getType(scope.item.type)))])]
      }
    }, {
      key: "inn",
      fn: function(scope) {
        return [_c('span', [_vm._v(" " + _vm._s(((scope.item.inn) ? scope.item.inn : ((scope.item.passport_number) ? scope.item.passport_number : ''))))])]
      }
    }, {
      key: "nds",
      fn: function(scope) {
        return [_c('span', [_vm._v(" " + _vm._s((scope.item.nds && parseInt(scope.item.nds) === 1) ? 'Да' : 'Нет'))])]
      }
    }, {
      key: "liquidated",
      fn: function(scope) {
        return [_c('span', [_vm._v(" " + _vm._s((scope.item.liquidated && parseInt(scope.item.liquidated) === 1) ? 'Да' : 'Нет'))])]
      }
    }, {
      key: "is_agent",
      fn: function(scope) {
        return [(scope.item.is_agent && parseInt(scope.item.is_agent) == 1) ? _c('span', [_vm._v(" Перевозчик")]) : _c('span', [_vm._v(" Клиент")])]
      }
    }, {
      key: "actions",
      fn: function(scope) {
        return [_c('z-icon-button', {
          attrs: {
            "icon": ['fa', 'trash'],
            "danger-light": "",
            "rounded": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              $event.preventDefault();
              _vm.onRemove(scope.item.id)
            }
          }
        })]
      }
    }]),
    model: {
      value: (_vm.customers),
      callback: function($$v) {
        _vm.customers = $$v
      },
      expression: "customers"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b32f9aca","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/customers/views/Customers.vue
// module id = 1241
// module chunks = 0